module.exports = __webpack_public_path__ + "static/media/Client9QuayPacific.43774346.png";